
import bathroomVanityWhite from "@/assets/bathroom-vanity-white.jpeg";
import mudRoom from "@/assets/mud-room.jpeg";
import greenKitchen from "@/assets/green-kitchen.jpeg";
import laundryGreen from "@/assets/laundry-green.jpeg";
import kitchenGray from "@/assets/kitchen-gray.jpg";
import laundryMint from "@/assets/laundry-mint.jpeg";
import bathroomVanity2 from "@/assets/bathroom-vanity-2.jpg";
import whiteCabinetGoldPull from "@/assets/white-cabinet-gold-pull.jpeg";
import kitchenWhiteIsland from "@/assets/kitchen-white-island.jpeg";
import kitchenWhiteMarble from "@/assets/kitchen-white-marble.jpeg";
import bathroomVanity3 from "@/assets/bathroom-vanity-3.jpg";
import whiteKitchenGold from "@/assets/white-kitchen-gold.jpeg";
import kitchenWineRack from "@/assets/kitchen-wine-rack.jpeg";
import kitchenSkylights from "@/assets/kitchen-skylights.jpeg";
import bathroomVanity1 from "@/assets/bathroom-vanity-1.jpg";
import woodenIsland from "@/assets/wooden-island.jpg";
import tigerMapleKitchen from "@/assets/tiger-maple-kitchen.jpeg";
import tigerMapleBacksplash from "@/assets/tiger-maple-backsplash.jpeg";
import tigerMapleSink from "@/assets/tiger-maple-sink.jpeg";
import marbleFaucet from "@/assets/marble-faucet.jpeg";
import copperHoodRange from "@/assets/copper-hood-range.jpeg";
import tigerMapleMicrowave from "@/assets/tiger-maple-microwave.jpeg";
import tigerMapleFridge from "@/assets/tiger-maple-fridge.jpeg";
import tigerMapleWall from "@/assets/tiger-maple-wall.jpeg";
import kitchenCreamIsland from "@/assets/kitchen-cream-island.jpeg.asset.json";
import kitchenCreamPendants from "@/assets/kitchen-cream-pendants.jpeg.asset.json";

export type GalleryCategory = "Kitchens" | "Bathrooms" | "Laundry" | "Custom";

export interface GalleryImageData {
  src: string;
  alt: string;
  categories: GalleryCategory[];
  isHardcoded?: boolean;
}

export const hardcodedGalleryImages: GalleryImageData[] = [
  { src: kitchenCreamIsland.url, alt: "Cream kitchen with marble island, brass lantern pendants, and farmhouse sink", categories: ["Kitchens"] },
  { src: kitchenCreamPendants.url, alt: "Cream shaker kitchen with marble island and brass pendant lighting", categories: ["Kitchens"] },
  
  
  { src: bathroomVanityWhite, alt: "Bathroom vanity with white cabinetry and gold hardware", categories: ["Bathrooms"] },
  { src: mudRoom, alt: "Custom mud room cabinetry", categories: ["Custom"] },
  { src: copperHoodRange, alt: "Copper range hood with marble backsplash and tiger maple cabinets", categories: ["Kitchens"] },
  { src: greenKitchen, alt: "Green kitchen cabinets with sink", categories: ["Kitchens"] },
  { src: tigerMapleBacksplash, alt: "Tiger maple cabinets with marble backsplash and glass doors", categories: ["Kitchens"] },
  { src: laundryGreen, alt: "Green custom laundry cabinets with wooden top", categories: ["Laundry"] },
  { src: kitchenGray, alt: "Modern kitchen with gray cabinets and granite countertops", categories: ["Kitchens"] },
  { src: tigerMapleSink, alt: "Tiger maple cabinets with soapstone sink detail", categories: ["Kitchens"] },
  { src: laundryMint, alt: "Laundry room with mint green cabinets", categories: ["Laundry"] },
  { src: bathroomVanity2, alt: "Custom bathroom vanity", categories: ["Bathrooms"] },
  { src: marbleFaucet, alt: "Marble countertop with copper faucet detail", categories: ["Kitchens"] },
  { src: whiteCabinetGoldPull, alt: "White drawer cabinet with golden cup pull", categories: ["Custom"] },
  { src: kitchenWhiteIsland, alt: "Spacious kitchen with white cabinetry and large island", categories: ["Kitchens"] },
  
  { src: kitchenWhiteMarble, alt: "Kitchen with white cabinets and marble countertops", categories: ["Kitchens"] },
  { src: bathroomVanity3, alt: "Custom bathroom vanity design", categories: ["Bathrooms"] },
  { src: tigerMapleFridge, alt: "Tiger maple cabinetry surrounding French door refrigerator", categories: ["Kitchens"] },
  { src: whiteKitchenGold, alt: "White kitchen with golden hardware and farmhouse sink", categories: ["Kitchens"] },
  { src: kitchenWineRack, alt: "Kitchen with wine rack and farmhouse sink", categories: ["Kitchens"] },
  { src: tigerMapleWall, alt: "Tiger maple wall cabinets with marble backsplash", categories: ["Kitchens"] },
  { src: kitchenSkylights, alt: "Kitchen with large wooden island and skylights", categories: ["Kitchens"] },
  { src: bathroomVanity1, alt: "Elegant bathroom vanity", categories: ["Bathrooms"] },
  { src: woodenIsland, alt: "Custom stained wooden island", categories: ["Kitchens", "Custom"] },
];

export const ALL_CATEGORIES: GalleryCategory[] = ["Kitchens", "Bathrooms", "Laundry", "Custom"];
